import { Controller } from '@hotwired/stimulus'

// Footer link groups: collapsible on phones, always open from the tablet breakpoint up.
// Rendered open, so the links stay visible without JavaScript. The height is animated here:
// Safari cannot animate a <details> in CSS yet.
export default class extends Controller {
  static targets = ['group']

  connect() {
    this.media = window.matchMedia('(min-width: 768px)')
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.sync = () => this.groupTargets.forEach((group) => { group.open = this.media.matches })
    this.sync()
    this.media.addEventListener('change', this.sync)
  }

  disconnect() {
    this.media.removeEventListener('change', this.sync)
  }

  // Summary click: from the tablet breakpoint up, a title is only a title. On phones, one group
  // open at a time.
  guard(event) {
    event.preventDefault()
    if (this.media.matches) return

    const group = event.currentTarget.parentElement
    const opening = !this.#isOpen(group)
    if (opening) this.groupTargets.filter((other) => other !== group && this.#isOpen(other)).forEach((other) => this.#toggle(other, false))
    this.#toggle(group, opening)
  }

  #toggle(group, opening) {
    if (this.reducedMotion.matches) {
      group.open = opening
      return
    }

    group.getAnimations().forEach((animation) => animation.cancel())
    const start = group.offsetHeight
    group.open = true
    group.toggleAttribute('data-closing', !opening)
    const end = opening ? group.offsetHeight : this.#closedHeight(group)

    group.style.overflow = 'hidden'
    const animation = group.animate({ height: [`${start}px`, `${end}px`] }, { duration: 250, easing: 'ease-out' })
    animation.onfinish = () => {
      group.open = opening
      group.removeAttribute('data-closing')
      group.style.overflow = ''
    }
  }

  // A closing group stays `open` until its animation ends: a tap meanwhile reopens it.
  #isOpen(group) {
    return group.open && !group.hasAttribute('data-closing')
  }

  #border(group) {
    return parseFloat(getComputedStyle(group).borderBottomWidth)
  }

  #closedHeight(group) {
    const summary = group.querySelector('summary')
    return summary.offsetHeight + this.#border(group)
  }
}
